import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class TrainAndContentService extends AxiosBase {
  deleteContents = async ({ fileIds, navigate }) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.TRAINFROMECONTENT.DELETE_CONTENTS}`,
        { fileIds }
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  getAllDocuments = async (page, limit, type, navigate, searchQuery) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.TRAINFROMECONTENT.GET_UPLOADED_DOCUMENT}?page=${page}&limit=${limit}&type=${type}&searchQuery=${searchQuery}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  updateContentRoles = async (contentId, roleIds, navigate) => {
    try {
      const response = await this.requests.patch(
        `${API_ROUTES.TRAINFROMECONTENT.UPDATE_CONTENT_ROLES}/${contentId}`,
        { roleIds }
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  getAllDocumentsProfile = async (page, limit, navigate, searchQuery) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.TRAINFROMECONTENT.GET_UPLOADED_DOCUMENT}?page=${page}&limit=${limit}&searchQuery=${searchQuery}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  getAllCustomData = async (page, limit, navigate, searchQuery) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.TRAINFROMECONTENT.GET_CUSTOM_API}?page=${page}&limit=${limit}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  removeCustomData = async (body, userId, navigate) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.TRAINFROMECONTENT.CUSTOM_API}/${userId}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  updateCustomData = async ({ id, body, navigate }) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.TRAINFROMECONTENT.CUSTOM_API}/${id}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  createCustomData = async (body, navigate) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.TRAINFROMECONTENT.CUSTOM_API}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  getSingleData = async (id, navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.TRAINFROMECONTENT.GET_SINGLE_DATA}/${id}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
  getCustomAction = async (navigate, searchQuery) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.TRAINFROMECONTENT.GET_CUSTOM_ACTION_API}?searchQuery=${searchQuery}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  getAllNotifications = async (navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.TRAINFROMECONTENT.GET_ALL_NOTIFICATIONS}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
}
